import { useEffect } from "react";
import { useSelector } from "react-redux";

function InnsynPersonopplysningerResult() {
  const { result, noResult, hasBeenSubmitted } = useSelector(
    (store) => store.innsynPersonopplysninger,
  );

  useEffect(() => {
    console.log("State updated:", { result, noResult, hasBeenSubmitted });
  }, [result, noResult, hasBeenSubmitted]);

  if (!hasBeenSubmitted) return null;

  if (noResult || !result)
    return <div style={{ padding: "0 50px" }}>Ingen data funnet</div>;

  return (
    <div
      style={{
        padding: "10px 50px 20px 50px",
      }}
    >
      <b>Svar på innsynsforespørselen med følgende:</b>
      <p>
        <i dangerouslySetInnerHTML={{ __html: result }} />
      </p>
    </div>
  );
}

export default InnsynPersonopplysningerResult;
